<template>
  <template-post-action-menu></template-post-action-menu>
</template>

<script lang="ts">

import templatePostActionMenu from '@/app-template/lib/components/PostActionMenu.vue';

export default {
  components: { templatePostActionMenu },
};
</script>